module.exports = __webpack_public_path__ + "img/country.95e42992.png";